module.exports = "images/kultur_hamburger_kulturstiftung.jpg";